// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "stop--Mhx6";
export { _1 as "__esModule", _2 as "stop" }
export default { "__esModule": _1, "stop": _2 }
